import { HttpInterceptorFn, HttpErrorResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { EMPTY, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { BYPASS_GLOBAL_ERROR_PAGE } from './http-error.tokens';
import { AppConfig } from '../constant';

// Only our own backend(s) count as a "server error" worth taking over the whole
// screen for. Third-party calls (MaxMind geoip-js, Firebase REST, i18n asset
// files, etc.) keep failing the way they already do (silently falling back,
// their own toast, ...) instead of hijacking navigation.
const OWN_BACKEND_PREFIXES = [AppConfig.API_BASE_URL, AppConfig.PHP_BASE_URL].filter(Boolean);

/**
 * Any real HTTP-level failure from our own backend (network down, 4xx/5xx)
 * routes straight to the 500 page instead of each component showing its own
 * generic error toast. Business-logic failures returned inside a 200 OK body
 * (e.g. { success: 0 }) never pass through here, so those messages are
 * unaffected. Requests that already handle their own HTTP errors (e.g. a
 * retry loop) can opt out via BYPASS_GLOBAL_ERROR_PAGE.
 */
export const serverErrorInterceptor: HttpInterceptorFn = (req, next) => {
  const router = inject(Router);

  return next(req).pipe(
    catchError((error: unknown) => {
      const isOwnBackendRequest = OWN_BACKEND_PREFIXES.some(prefix => req.url.startsWith(prefix));

      if (error instanceof HttpErrorResponse && isOwnBackendRequest && !req.context.get(BYPASS_GLOBAL_ERROR_PAGE)) {
        router.navigateByUrl('/server-error');
        return EMPTY;
      }
      return throwError(() => error);
    })
  );
};
